import { bootstrapApplication } from '@angular/platform-browser'
import * as Sentry from '@sentry/angular'

import { appConfig } from './app/app.config'
import { AppComponent } from './app/app.component'
import { environment } from './app/environments/environment'

Sentry.init({
  dsn: 'https://be2df0e69e699cb12594ceda080f4a43@o474392.ingest.us.sentry.io/4508754994528256',
  environment: environment.sentry.environment,
  integrations: [],
})

bootstrapApplication(AppComponent, appConfig).catch(err => console.error(err))
